import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useEffect } from 'react'
import { useChildStore } from '../state/store.js'
import { fetchFlags } from '../state/sync.js'
import { log, reason } from './log.js'

const logger = log('providers')

/** Offline first: server state is a nicety, so nothing retries forever or refetches on focus. */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      networkMode: 'offlineFirst',
    },
  },
})

export function Providers({ children }: { children: ReactNode }) {
  const boot = useChildStore((store) => store.boot)
  const setFlags = useChildStore((store) => store.setFlags)

  useEffect(() => {
    void boot().catch((error) => logger.error('boot failed', reason(error)))
    void fetchFlags().then(setFlags)
  }, [boot, setFlags])

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
